// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__ShqxK","spin":"Spinner_spin__8jO52"};